<script setup>
  defineProps({
    item: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 1,
    },
  });
</script>

<template>
  <v-list-group :value="item.title" :data-id="item.id" no-action>
    <template #activator="{ props: activatorProps }">
      <NavDrawerItem v-bind="activatorProps" :item="item" :level="level" />
    </template>

    <template v-for="(subitem, index) in item.children" :key="`$item.id-child-${index}`">
      <NavDrawerGroup v-if="subitem.children" :item="subitem" :level="level + 1" />
      <NavDrawerItem v-else :item="subitem" :level="level + 1" />
    </template>
  </v-list-group>
</template>
